<template>
  <div class="agent-member-detail">
    <div class="header">
      <div class="back" @click="goBack">
        <i class="van-icon van-icon-arrow-left"></i>
      </div>
      <div class="title">{{ $t('member_details') }}</div>
    </div>
    <div class="content">
      <div class="member-info">
        <div class="info-item">
          <span class="label">{{ $t('member_account') }}</span>
          <span class="value">{{ memberInfo.username }}</span>
        </div>
        <div class="info-item">
          <span class="label">{{ $t('real_name') }}</span>
          <span class="value">{{ memberInfo.realname }}</span>
        </div>
        <div class="info-item">
          <span class="label">{{ $t('register_time') }}</span>
          <span class="value">{{ memberInfo.created_at }}</span>
        </div>
        <div class="info-item">
          <span class="label">{{ $t('current_balance') }}</span>
          <span class="value balance">{{ memberInfo.balance }}</span>
        </div>
      </div>
      
      <div class="tabs">
        <div class="tab" :class="{ active: activeTab === 'bet' }" @click="switchTab('bet')">{{ $t('bet_record') }}</div>
        <div class="tab" :class="{ active: activeTab === 'recharge' }" @click="switchTab('recharge')">{{ $t('recharge_record') }}</div>
        <div class="tab" :class="{ active: activeTab === 'withdraw' }" @click="switchTab('withdraw')">{{ $t('withdraw_record') }}</div>
        <div class="tab" :class="{ active: activeTab === 'profit' }" @click="switchTab('profit')">{{ $t('profit_loss_record') }}</div>
      </div>
      
      <div class="tab-content">
        <!-- 下注记录 -->
        <div v-if="activeTab === 'bet'" class="bet-record">
          <div class="date-filter">
            <input type="date" v-model="betDateRange.start" :placeholder="$t('start_date')">
            <span>{{ $t('to') }}</span>
            <input type="date" v-model="betDateRange.end" :placeholder="$t('end_date')">
            <button class="filter-btn" @click="searchBetRecord">{{ $t('query') }}</button>
          </div>
          <div class="record-list">
            <div class="record-item" v-for="record in betRecords" :key="record.id">
              <div class="record-info">
                <div class="game-name">{{ record.game_name || record.platform_type || '-' }}</div>
                <div class="bet-time">{{ record.created_at }}</div>
              </div>
              <div class="record-amount">
                <div class="bet-amount">{{ $t('bet_amount') }}: {{ record.bet_amount || record.valid_amount || 0 }}</div>
                <div class="win-loss" :class="{ win: (record.win_loss || 0) > 0, loss: (record.win_loss || 0) < 0 }">
                  {{ (record.win_loss || 0) > 0 ? '+' : '' }}{{ record.win_loss || 0 }}
                </div>
              </div>
            </div>
            <div class="no-data" v-if="betRecords.length === 0 && !betLoading">
              {{ $t('no_bet_records') }}
            </div>
          </div>
          <div class="pagination" v-if="betTotalPages > 1">
            <button class="page-btn" @click="changeBetPage(1)" :disabled="betCurrentPage === 1">{{ $t('first_page') }}</button>
            <button class="page-btn" @click="changeBetPage(betCurrentPage - 1)" :disabled="betCurrentPage === 1">{{ $t('prev_page') }}</button>
            <span class="page-info">{{ $t('page_info', { current: betCurrentPage, total: betTotalPages }) }}</span>
            <button class="page-btn" @click="changeBetPage(betCurrentPage + 1)" :disabled="betCurrentPage === betTotalPages">{{ $t('next_page') }}</button>
            <button class="page-btn" @click="changeBetPage(betTotalPages)" :disabled="betCurrentPage === betTotalPages">{{ $t('last_page') }}</button>
          </div>
        </div>
        
        <!-- 充值记录 -->
        <div v-if="activeTab === 'recharge'" class="recharge-record">
          <div class="date-filter">
            <input type="date" v-model="rechargeDateRange.start" :placeholder="$t('start_date')">
            <span>{{ $t('to') }}</span>
            <input type="date" v-model="rechargeDateRange.end" :placeholder="$t('end_date')">
            <button class="filter-btn" @click="searchRechargeRecord">{{ $t('query') }}</button>
          </div>
          <div class="record-list">
            <div class="record-item" v-for="record in rechargeRecords" :key="record.id">
              <div class="record-info">
                <div class="pay-way">{{ record.pay_way }}</div>
                <div class="recharge-time">{{ record.created_at }}</div>
              </div>
              <div class="record-amount">
                <div class="amount">{{ $t('recharge_amount') }}: {{ record.amount }}</div>
                <div class="status" :class="{ success: record.state === 2 }">
                  {{ record.state === 2 ? $t('success') : $t('processing') }}
                </div>
              </div>
            </div>
            <div class="no-data" v-if="rechargeRecords.length === 0 && !rechargeLoading">
              {{ $t('no_recharge_records') }}
            </div>
          </div>
          <div class="pagination" v-if="rechargeTotalPages > 1">
            <button class="page-btn" @click="changeRechargePage(1)" :disabled="rechargeCurrentPage === 1">{{ $t('first_page') }}</button>
            <button class="page-btn" @click="changeRechargePage(rechargeCurrentPage - 1)" :disabled="rechargeCurrentPage === 1">{{ $t('prev_page') }}</button>
            <span class="page-info">{{ $t('page_info', { current: rechargeCurrentPage, total: rechargeTotalPages }) }}</span>
            <button class="page-btn" @click="changeRechargePage(rechargeCurrentPage + 1)" :disabled="rechargeCurrentPage === rechargeTotalPages">{{ $t('next_page') }}</button>
            <button class="page-btn" @click="changeRechargePage(rechargeTotalPages)" :disabled="rechargeCurrentPage === rechargeTotalPages">{{ $t('last_page') }}</button>
          </div>
        </div>
        
        <!-- 提现记录 -->
        <div v-if="activeTab === 'withdraw'" class="withdraw-record">
          <div class="date-filter">
            <input type="date" v-model="withdrawDateRange.start" :placeholder="$t('start_date')">
            <span>{{ $t('to') }}</span>
            <input type="date" v-model="withdrawDateRange.end" :placeholder="$t('end_date')">
            <button class="filter-btn" @click="searchWithdrawRecord">{{ $t('query') }}</button>
          </div>
          <div class="record-list">
            <div class="record-item" v-for="record in withdrawRecords" :key="record.id">
              <div class="record-info">
                <div class="bank-card">{{ record.bank_card || record.pay_way || '-' }}</div>
                <div class="withdraw-time">{{ record.created_at }}</div>
              </div>
              <div class="record-amount">
                <div class="amount">{{ $t('withdraw_amount') }}: {{ record.amount || record.real_money || 0 }}</div>
                <div class="status" :class="{ success: record.state === 2 }">
                  {{ record.state === 2 ? $t('success') : $t('processing') }}
                </div>
              </div>
            </div>
            <div class="no-data" v-if="withdrawRecords.length === 0 && !withdrawLoading">
              {{ $t('no_withdraw_records') }}
            </div>
          </div>
          <div class="pagination" v-if="withdrawTotalPages > 1">
            <button class="page-btn" @click="changeWithdrawPage(1)" :disabled="withdrawCurrentPage === 1">{{ $t('first_page') }}</button>
            <button class="page-btn" @click="changeWithdrawPage(withdrawCurrentPage - 1)" :disabled="withdrawCurrentPage === 1">{{ $t('prev_page') }}</button>
            <span class="page-info">{{ $t('page_info', { current: withdrawCurrentPage, total: withdrawTotalPages }) }}</span>
            <button class="page-btn" @click="changeWithdrawPage(withdrawCurrentPage + 1)" :disabled="withdrawCurrentPage === withdrawTotalPages">{{ $t('next_page') }}</button>
            <button class="page-btn" @click="changeWithdrawPage(withdrawTotalPages)" :disabled="withdrawCurrentPage === withdrawTotalPages">{{ $t('last_page') }}</button>
          </div>
        </div>
        
        <!-- 盈亏记录 -->
        <div v-if="activeTab === 'profit'" class="profit-record">
          <div class="date-filter">
            <input type="date" v-model="profitDateRange.start" :placeholder="$t('start_date')">
            <span>{{ $t('to') }}</span>
            <input type="date" v-model="profitDateRange.end" :placeholder="$t('end_date')">
            <button class="filter-btn" @click="searchProfitRecord">{{ $t('query') }}</button>
          </div>
          <div class="profit-summary">
            <div class="summary-item">
              <span class="label">{{ $t('total_recharge') }}</span>
              <span class="value">{{ profitSummary.totalRecharge }}</span>
            </div>
            <div class="summary-item">
              <span class="label">{{ $t('total_withdraw') }}</span>
              <span class="value">{{ profitSummary.totalWithdraw }}</span>
            </div>
            <div class="summary-item">
              <span class="label">{{ $t('total_bet') }}</span>
              <span class="value">{{ profitSummary.totalBet }}</span>
            </div>
            <div class="summary-item">
              <span class="label">{{ $t('total_profit_loss') }}</span>
              <span class="value" :class="{ win: profitSummary.totalProfit > 0, loss: profitSummary.totalProfit < 0 }">
                {{ profitSummary.totalProfit > 0 ? '+' : '' }}{{ profitSummary.totalProfit }}
              </span>
            </div>
          </div>
          <div class="record-list">
            <div class="record-item" v-for="record in profitRecords" :key="record.id">
              <div class="record-info">
                <div class="date">{{ record.date || (record.created_at ? record.created_at.split(' ')[0] : '') || '-' }}</div>
              </div>
              <div class="record-amount">
                <div class="bet-amount">{{ $t('bet_amount') }}: {{ record.bet_amount || record.betAmount || record.valid_amount || 0 }}</div>
                <div class="win-loss" :class="{ win: (record.win_loss || record.winLoss || 0) > 0, loss: (record.win_loss || record.winLoss || 0) < 0 }">
                  {{ (record.win_loss || record.winLoss || 0) > 0 ? '+' : '' }}{{ record.win_loss || record.winLoss || 0 }}
                </div>
              </div>
            </div>
            <div class="no-data" v-if="profitRecords.length === 0 && !profitLoading">
              {{ $t('no_profit_loss_records') }}
            </div>
          </div>
          <div class="pagination" v-if="profitTotalPages > 1">
            <button class="page-btn" @click="changeProfitPage(1)" :disabled="profitCurrentPage === 1">{{ $t('first_page') }}</button>
            <button class="page-btn" @click="changeProfitPage(profitCurrentPage - 1)" :disabled="profitCurrentPage === 1">{{ $t('prev_page') }}</button>
            <span class="page-info">{{ $t('page_info', { current: profitCurrentPage, total: profitTotalPages }) }}</span>
            <button class="page-btn" @click="changeProfitPage(profitCurrentPage + 1)" :disabled="profitCurrentPage === profitTotalPages">{{ $t('next_page') }}</button>
            <button class="page-btn" @click="changeProfitPage(profitTotalPages)" :disabled="profitCurrentPage === profitTotalPages">{{ $t('last_page') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'agentMemberDetail',
  data() {
    return {
      memberId: '',
      memberInfo: {
        username: '',
        realname: '',
        created_at: '',
        balance: 0
      },
      activeTab: 'bet',
      
      // 下注记录
      betRecords: [],
      betCurrentPage: 1,
      betTotalPages: 1,
      betLoading: false,
      betDateRange: {
        start: '',
        end: ''
      },
      
      // 充值记录
      rechargeRecords: [],
      rechargeCurrentPage: 1,
      rechargeTotalPages: 1,
      rechargeLoading: false,
      rechargeDateRange: {
        start: '',
        end: ''
      },
      
      // 提现记录
      withdrawRecords: [],
      withdrawCurrentPage: 1,
      withdrawTotalPages: 1,
      withdrawLoading: false,
      withdrawDateRange: {
        start: '',
        end: ''
      },
      
      // 盈亏记录
      profitRecords: [],
      profitCurrentPage: 1,
      profitTotalPages: 1,
      profitLoading: false,
      profitDateRange: {
        start: '',
        end: ''
      },
      profitSummary: {
        totalRecharge: 0,
        totalWithdraw: 0,
        totalBet: 0,
        totalProfit: 0
      }
    };
  },
  created() {
    this.memberId = this.$route.params.id;
    this.getMemberInfo();
    this.getBetRecord();
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    
    switchTab(tab) {
      this.activeTab = tab;
      if (tab === 'bet' && this.betRecords.length === 0) {
        this.getBetRecord();
      } else if (tab === 'recharge' && this.rechargeRecords.length === 0) {
        this.getRechargeRecord();
      } else if (tab === 'withdraw' && this.withdrawRecords.length === 0) {
        this.getWithdrawRecord();
      } else if (tab === 'profit' && this.profitRecords.length === 0) {
        this.getProfitRecord();
      }
    },
    
    getMemberInfo() {
      let that = this;
      this.$apiFun.get(`/api/user/${this.memberId}`).then(res => {
        console.log('会员信息返回:', res);
        if (res.code === 200) {
          that.memberInfo = res.data;
        }
      }).catch(err => {
        console.error('获取会员信息失败:', err);
      });
    },
    
    // ========== 下注记录 ==========
    getBetRecord() {
      let that = this;
      that.betLoading = true;
      let url = `/api/team/member/bet/${this.memberId}?page=${this.betCurrentPage}`;
      if (this.betDateRange.start) url += `&start=${this.betDateRange.start}`;
      if (this.betDateRange.end) url += `&end=${this.betDateRange.end}`;
      
      console.log('请求下注记录URL:', url);
      console.log('当前请求页码:', this.betCurrentPage);
      
      this.$apiFun.get(url).then(res => {
        console.log('下注记录返回:', res);
        if (res.code === 200 && res.data) {
          that.betRecords = res.data.data || [];
          that.betTotalPages = res.data.totalPages || 1;
          // 删除下面这行！不要从后端获取 current_page
          // that.betCurrentPage = res.data.current_page || 1;
          console.log('返回数据条数:', that.betRecords.length, '总页数:', that.betTotalPages);
        }
        that.betLoading = false;
      }).catch(err => {
        console.error('获取下注记录失败:', err);
        that.betLoading = false;
      });
    },
    
    searchBetRecord() {
      this.betCurrentPage = 1;
      this.getBetRecord();
    },
    
    changeBetPage(page) {
      console.log('切换页码: 从', this.betCurrentPage, '到', page);
      if (page >= 1 && page <= this.betTotalPages && page !== this.betCurrentPage) {
        this.betCurrentPage = page;
        this.getBetRecord();
      }
    },
    
    // ========== 充值记录 ==========
    getRechargeRecord() {
      let that = this;
      that.rechargeLoading = true;
      let url = `/api/team/member/recharge/${this.memberId}?page=${this.rechargeCurrentPage}`;
      if (this.rechargeDateRange.start) url += `&start=${this.rechargeDateRange.start}`;
      if (this.rechargeDateRange.end) url += `&end=${this.rechargeDateRange.end}`;
      
      this.$apiFun.get(url).then(res => {
        console.log('充值记录返回:', res);
        if (res.code === 200 && res.data) {
          that.rechargeRecords = res.data.data || [];
          that.rechargeTotalPages = res.data.totalPages || 1;
          // 删除这行
          // that.rechargeCurrentPage = res.data.current_page || 1;
        }
        that.rechargeLoading = false;
      }).catch(err => {
        console.error('获取充值记录失败:', err);
        that.rechargeLoading = false;
      });
    },
    
    searchRechargeRecord() {
      this.rechargeCurrentPage = 1;
      this.getRechargeRecord();
    },
    
    changeRechargePage(page) {
      if (page >= 1 && page <= this.rechargeTotalPages && page !== this.rechargeCurrentPage) {
        this.rechargeCurrentPage = page;
        this.getRechargeRecord();
      }
    },
    
    // ========== 提现记录 ==========
    getWithdrawRecord() {
      let that = this;
      that.withdrawLoading = true;
      let url = `/api/team/member/withdraw/${this.memberId}?page=${this.withdrawCurrentPage}`;
      if (this.withdrawDateRange.start) url += `&start=${this.withdrawDateRange.start}`;
      if (this.withdrawDateRange.end) url += `&end=${this.withdrawDateRange.end}`;
      
      this.$apiFun.get(url).then(res => {
        console.log('提现记录返回:', res);
        if (res.code === 200 && res.data) {
          that.withdrawRecords = res.data.data || [];
          that.withdrawTotalPages = res.data.totalPages || 1;
          // 删除这行
          // that.withdrawCurrentPage = res.data.current_page || 1;
        }
        that.withdrawLoading = false;
      }).catch(err => {
        console.error('获取提现记录失败:', err);
        that.withdrawLoading = false;
      });
    },
    
    searchWithdrawRecord() {
      this.withdrawCurrentPage = 1;
      this.getWithdrawRecord();
    },
    
    changeWithdrawPage(page) {
      if (page >= 1 && page <= this.withdrawTotalPages && page !== this.withdrawCurrentPage) {
        this.withdrawCurrentPage = page;
        this.getWithdrawRecord();
      }
    },
    
    // ========== 盈亏记录 ==========
    getProfitRecord() {
      let that = this;
      that.profitLoading = true;
      let url = `/api/team/member/profit/${this.memberId}?page=${this.profitCurrentPage}`;
      if (this.profitDateRange.start) url += `&start=${this.profitDateRange.start}`;
      if (this.profitDateRange.end) url += `&end=${this.profitDateRange.end}`;
      
      this.$apiFun.get(url).then(res => {
        console.log('盈亏记录返回:', res);
        if (res.code === 200 && res.data) {
          that.profitRecords = res.data.data || [];
          that.profitTotalPages = res.data.totalPages || 1;
          // 删除这行
          // that.profitCurrentPage = res.data.current_page || 1;
          that.profitSummary = res.data.summary || {
            totalRecharge: 0,
            totalWithdraw: 0,
            totalBet: 0,
            totalProfit: 0
          };
        }
        that.profitLoading = false;
      }).catch(err => {
        console.error('获取盈亏记录失败:', err);
        that.profitLoading = false;
      });
    },
    
    searchProfitRecord() {
      this.profitCurrentPage = 1;
      this.getProfitRecord();
    },
    
    changeProfitPage(page) {
      if (page >= 1 && page <= this.profitTotalPages && page !== this.profitCurrentPage) {
        this.profitCurrentPage = page;
        this.getProfitRecord();
      }
    }
  }
};
</script>

<style scoped>
.agent-member-detail {
  padding-top: 60px;
  min-height: 100vh;
  background: #f5f5f5;
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  background: url(/img/counter/top-bg.webp) no-repeat #084ccb;
  background-size: cover;
  display: flex;
  align-items: center;
  padding: 0 20px;
  z-index: 100;
}

.back {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.back i {
  font-size: 20px;
  color: #fff;
  transition: all 0.3s ease;
}

.back:hover i {
  transform: translateX(-2px);
}

.title {
  flex: 1;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: #fff;
}

.content {
  padding: 20px;
}

.member-info {
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.info-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #f0f0f0;
}

.info-item:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.info-item .label {
  font-size: 16px;
  color: #666;
}

.info-item .value {
  font-size: 16px;
  color: #333;
  font-weight: bold;
}

.info-item .balance {
  color: #084ccb;
}

.tabs {
  display: flex;
  background: #fff;
  border-radius: 10px;
  margin-bottom: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.tab {
  flex: 1;
  text-align: center;
  padding: 15px;
  font-size: 16px;
  color: #666;
  cursor: pointer;
  border-bottom: 2px solid transparent;
}

.tab.active {
  color: #084ccb;
  border-bottom-color: #084ccb;
  font-weight: bold;
}

.tab-content {
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.date-filter {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 10px;
}

.date-filter input {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 5px;
}

.date-filter span {
  color: #666;
}

.filter-btn {
  padding: 8px 20px;
  background: #084ccb;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.record-list {
  margin-bottom: 20px;
  max-height: 500px;
  overflow-y: auto;
}

.record-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border-bottom: 1px solid #f0f0f0;
}

.record-item:last-child {
  border-bottom: none;
}

.record-info {
  flex: 1;
}

.game-name, .pay-way, .bank-card, .date {
  font-size: 16px;
  color: #333;
  margin-bottom: 5px;
  font-weight: 500;
}

.bet-time, .recharge-time, .withdraw-time {
  font-size: 12px;
  color: #999;
}

.record-amount {
  text-align: right;
}

.bet-amount, .amount {
  font-size: 14px;
  color: #666;
  margin-bottom: 5px;
}

.win-loss {
  font-size: 16px;
  font-weight: bold;
}

.win-loss.win {
  color: #00c853;
}

.win-loss.loss {
  color: #ff3b30;
}

.status {
  font-size: 14px;
}

.status.success {
  color: #00c853;
}

.no-data {
  text-align: center;
  padding: 40px;
  color: #999;
  font-size: 16px;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  flex-wrap: wrap;
  gap: 8px;
}

.page-btn {
  padding: 6px 12px;
  border: 1px solid #ddd;
  background: #fff;
  border-radius: 5px;
  cursor: pointer;
}

.page-btn:disabled {
  color: #999;
  cursor: not-allowed;
}

.page-info {
  margin: 0 10px;
  font-size: 14px;
  color: #666;
}

.profit-summary {
  display: flex;
  justify-content: space-around;
  margin-bottom: 20px;
  padding: 20px;
  background: #f5f5f5;
  border-radius: 10px;
  flex-wrap: wrap;
  gap: 15px;
}

.summary-item {
  text-align: center;
  min-width: 80px;
}

.summary-item .label {
  font-size: 12px;
  color: #666;
  margin-bottom: 5px;
  display: block;
}

.summary-item .value {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.summary-item .value.win {
  color: #00c853;
}

.summary-item .value.loss {
  color: #ff3b30;
}
</style>


// WEBPACK FOOTER //
// src/components/agentMemberDetail.vue